"use client"

import { useEffect, useState } from "react"
import { BASEAPIURL, token } from "../../env"

const MenuList = ({ location, onBack }) => {
  const [menuItems, setMenuItems] = useState([])
  const [menuFilter, setMenuFilter] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const itemsPerPage = 9
  const [cartItems, setCartItems] = useState({})
  const [showReceiverModal, setShowReceiverModal] = useState(false)
  const [receiverInfo, setReceiverInfo] = useState({
    name: "",
    phone: "",
    address: "",
  })
  const [showMobileCart, setShowMobileCart] = useState(false)
  const memberID = sessionStorage.getItem("MemberID");

  // Fetch menu items from API
  const fetchMenuItems = async () => {
    try {
      const url = `${BASEAPIURL}/ProductByCategoryAndLocationWithoutImage?MainID=0&LocID=3&Status=${menuFilter}`
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tokenData: token }),
      })
      const result = await response.json()
      const items = Array.isArray(result) ? result : result?.data || result?.ProductList || []
      setMenuItems(items)
      setCurrentPage(1)
    } catch (error) {
      console.error("Error fetching menu items:", error)
    }
  }

  useEffect(() => {
    fetchMenuItems()
  }, [location, menuFilter])

  const calculateGST = (baseTotal, item) => {
    const cgst = ((item.ProdCGSTPer || 0) * baseTotal) / 100
    const sgst = ((item.ProdSGSTPer || 0) * baseTotal) / 100
    const igst = ((item.ProdIGSTPer || 0) * baseTotal) / 100
    return { cgst, sgst, igst, total: cgst + sgst + igst }
  }

  const addToCart = (item) => {
    const idKey = String(item.ProdID)
    setCartItems((prev) => {
      const quantityHalf = (prev[idKey]?.quantityHalf || 0) + 1
      const quantityFull = prev[idKey]?.quantityFull || 0
      const baseTotal = quantityHalf * (item.ProdHalfPrice || 0) + quantityFull * (item.ProdFullPrice || 0)
      const { cgst, sgst, igst, total } = calculateGST(baseTotal, item)

      return {
        ...prev,
        [idKey]: {
          ...item,
          quantityHalf,
          quantityFull,
          totalPrice: baseTotal + total,
          cgst,
          sgst,
          igst,
          gstAmount: total,
        },
      }
    })
  }

  const removeFromCart = (prodId) => {
    const idKey = String(prodId)
    setCartItems((prev) => {
      const copy = { ...prev }
      delete copy[idKey]
      return copy
    })
  }

  const updateCartItemQuantity = (prodId, field, value) => {
    const idKey = String(prodId)
    const qty = Math.max(0, Number(value) || 0)
    setCartItems((prev) => {
      if (!prev[idKey]) return prev
      const item = prev[idKey]
      const quantityHalf = field === "quantityHalf" ? qty : item.quantityHalf
      const quantityFull = field === "quantityFull" ? qty : item.quantityFull
      const baseTotal = quantityHalf * (item.ProdHalfPrice || 0) + quantityFull * (item.ProdFullPrice || 0)
      const { cgst, sgst, igst, total } = calculateGST(baseTotal, item)

      if (quantityHalf === 0 && quantityFull === 0) {
        const copy = { ...prev }
        delete copy[idKey]
        return copy
      }

      return {
        ...prev,
        [idKey]: {
          ...item,
          quantityHalf,
          quantityFull,
          totalPrice: baseTotal + total,
          cgst,
          sgst,
          igst,
          gstAmount: total,
        },
      }
    })
  }

  const paginatedMenuItems = menuItems.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
  const totalPages = Math.ceil(menuItems.length / itemsPerPage)

  const cartTotal = Object.values(cartItems).reduce((sum, item) => sum + item.totalPrice, 0)
  const totalCGST = Object.values(cartItems).reduce((sum, item) => sum + (item.cgst || 0), 0)
  const totalSGST = Object.values(cartItems).reduce((sum, item) => sum + (item.sgst || 0), 0)
  const totalIGST = Object.values(cartItems).reduce((sum, item) => sum + (item.igst || 0), 0)

  const cartItemCount = Object.values(cartItems).reduce((sum, item) => sum + item.quantityHalf + item.quantityFull, 0)

  // Instead of directly saving cart, open modal for receiver details
  const handleProceedToPay = () => {
    const itemsArray = Object.values(cartItems).filter((item) => item.quantityHalf > 0 || item.quantityFull > 0)
    if (itemsArray.length === 0) {
      alert("Please add at least one item to cart.")
      return
    }
    setShowReceiverModal(true)
    setShowMobileCart(false) // Hide mobile cart when proceeding to pay
  }

  const handleReceiverChange = (e) => {
    const { name, value } = e.target
    setReceiverInfo((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleReceiverSubmit = () => {
    if (!receiverInfo.name || !receiverInfo.phone || !receiverInfo.address) {
      alert("Please fill in all receiver details.")
      return
    }
    console.log("Order placed:", { cartItems, receiverInfo })

    localStorage.setItem("cart", JSON.stringify(Object.values(cartItems)))
    localStorage.setItem("receiverInfo", JSON.stringify(receiverInfo))

    setCartItems({})
    setReceiverInfo({ name: "", phone: "", address: "" })
    setShowReceiverModal(false)

    alert("Order placed successfully!")
    // navigate("/dashboard"); // optional
  }

  return (
    <>
      <style>{`
        @media print {
          body * {
            visibility: hidden;
          }
          .invoice-print {
            visibility: visible;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            padding: 20px;
          }
        }
        .invoice-table th, .invoice-table td {
          font-size: 0.9rem;
        }
        
        /* Responsive styles */
        .menu-container {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          padding: 1rem;
        }
        
        @media (min-width: 992px) {
          .menu-container {
            flex-direction: row;
            padding: 2rem;
          }
        }
        
        .menu-items {
          flex: 2;
        }
        
        .cart-summary {
          flex: 1;
          min-width: 280px;
          border: 1px solid #ddd;
          padding: 1rem;
          border-radius: 6px;
          position: relative;
        }
        
        @media (max-width: 991px) {
          .cart-summary {
            z-index: 998; /* lower than modal (typically 1050) */
          }

          .modal-backdrop {
            z-index: 1050;
          }

          .offcanvas-backdrop {
            z-index: 1050;
          }

          .offcanvas {
            z-index: 1060;
          }
        }

          
          .cart-summary.expanded {
            transform: translateY(0);
          }
          
          .cart-preview {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0.5rem 1rem;
            cursor: pointer;
          }
        }
        
        .menu-card {
          height: 100%;
          display: flex;
          flex-direction: column;
          transition: transform 0.2s, box-shadow 0.2s;
        }
        
        .menu-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }
        
        .menu-card-body {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        
        .filter-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 1rem;
        }
        
        .quantity-input {
          width: 60px;
          text-align: center;
        }
        
        .cart-item {
          display: flex;
          flex-direction: column;
          padding-bottom: 0.75rem;
          margin-bottom: 0.75rem;
          border-bottom: 1px solid #eee;
        }
        
        @media (min-width: 576px) {
          .cart-item {
            flex-direction: row;
            align-items: center;
          }
        }
        
        .cart-item-details {
          flex: 2;
        }
        
        .cart-item-quantity {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          align-items: center;
          margin: 0.5rem 0;
        }
        
        @media (min-width: 576px) {
          .cart-item-quantity {
            flex: 2;
            margin: 0;
          }
        }
        
        .cart-item-price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex: 1;
        }
        
        .modal-backdrop {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1050;
        }
        
        .modal-content {
          background: white;
          border-radius: 8px;
          width: 90%;
          max-width: 500px;
          max-height: 90vh;
          overflow-y: auto;
        }
        
        @media (max-width: 576px) {
          .pagination {
            flex-wrap: wrap;
            justify-content: center;
          }
        }
      `}</style>

      <div className="menu-container">
        <div className="menu-items">
          <div className="filter-buttons">
            {["All", "Veg", "Non-Veg", "Egg"].map((label, idx) => (
              <button
                key={idx}
                className={`btn ${menuFilter === idx ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setMenuFilter(idx)}
              >
                {label}
              </button>
            ))}
          </div>

          <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
            {paginatedMenuItems.length > 0 ? (
              paginatedMenuItems.map((item) => {
                const idKey = String(item.ProdID)
                const isInCart = !!cartItems[idKey]
                return (
                  <div className="col" key={idKey}>
                    <div className="card menu-card h-100">
                      <div className="card-body menu-card-body p-3">
                        <div>
                          <h5 className="card-title">{item.ProdName}</h5>
                          <p className="card-subtitle text-muted small mb-2">
                            Half: ₹{item.ProdHalfPrice || "N/A"} | Full: ₹{item.ProdFullPrice || "N/A"}
                          </p>
                        </div>
                        <button
                          className={`btn ${isInCart ? "btn-success" : "btn-primary"} mt-2`}
                          onClick={() => addToCart(item)}
                          disabled={isInCart}
                        >
                          {isInCart ? "Added" : "Add to Cart"}
                        </button>
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <div className="col-12">
                <p className="text-center py-4">No menu items found.</p>
              </div>
            )}
          </div>

          {totalPages > 1 && (
            <nav className="mt-4 d-flex justify-content-center" aria-label="Page navigation">
              <ul className="pagination">
                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage - 1)}>
                    Previous
                  </button>
                </li>
                {[...Array(totalPages)].map((_, idx) => (
                  <li key={idx} className={`page-item d-none d-sm-block ${currentPage === idx + 1 ? "active" : ""}`}>
                    <button className="page-link" onClick={() => setCurrentPage(idx + 1)}>
                      {idx + 1}
                    </button>
                  </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                  <button className="page-link" onClick={() => setCurrentPage(currentPage + 1)}>
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          )}
        </div>

        {/* Cart Summary - Desktop and Mobile */}
        <div className={`cart-summary ${showMobileCart ? "expanded" : ""}`}>
          {/* Mobile Cart Preview Bar */}
          <div className="cart-preview d-lg-none" onClick={() => setShowMobileCart(!showMobileCart)}>
            <div className="d-flex align-items-center">
              <i className="bi bi-cart me-2"></i>
              <span>Your Cart</span>
              {cartItemCount > 0 && <span className="badge bg-primary rounded-pill ms-2">{cartItemCount}</span>}
            </div>
            <div className="d-flex align-items-center">
              <span className="me-3">₹{cartTotal.toFixed(2)}</span>
              <i className={`bi bi-chevron-${showMobileCart ? "down" : "up"}`}></i>
            </div>
          </div>

          {/* Cart Content */}
          <div className={`cart-content ${!showMobileCart && "d-none d-lg-block"}`}>
            <h5 className="d-lg-block d-none">Order Summary</h5>
            {Object.keys(cartItems).length === 0 ? (
              <p className="text-center py-3">No items selected.</p>
            ) : (
              <div>
                {Object.values(cartItems).map((item) => (
                  <div key={String(item.ProdID)} className="cart-item">
                    <div className="cart-item-details">
                      <strong>{item.ProdName}</strong>
                      <div className="small text-muted">
                        ₹{item.ProdHalfPrice} / Half | ₹{item.ProdFullPrice} / Full
                      </div>
                    </div>
                    <div className="cart-item-quantity">
                      <div>
                        <label className="form-label mb-0 small">Half</label>
                        <input
                          type="number"
                          min="0"
                          className="form-control form-control-sm quantity-input"
                          value={item.quantityHalf}
                          onChange={(e) => updateCartItemQuantity(item.ProdID, "quantityHalf", e.target.value)}
                        />
                      </div>
                      <div>
                        <label className="form-label mb-0 small">Full</label>
                        <input
                          type="number"
                          min="0"
                          className="form-control form-control-sm quantity-input"
                          value={item.quantityFull}
                          onChange={(e) => updateCartItemQuantity(item.ProdID, "quantityFull", e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="cart-item-price">
                      <span>₹{item.totalPrice.toFixed(2)}</span>
                      <button
                        className="btn btn-sm btn-danger ms-2"
                        title="Remove item"
                        onClick={() => removeFromCart(item.ProdID)}
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                ))}

                <hr />
                <div className="d-flex justify-content-between">
                  <span>CGST</span>
                  <span>₹{totalCGST.toFixed(2)}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>SGST</span>
                  <span>₹{totalSGST.toFixed(2)}</span>
                </div>
                <div className="d-flex justify-content-between">
                  <span>IGST</span>
                  <span>₹{totalIGST.toFixed(2)}</span>
                </div>
                <hr />
                <div className="d-flex justify-content-between fw-bold fs-5">
                  <div>Total</div>
                  <div>₹{cartTotal.toFixed(2)}</div>
                </div>

                <button className="btn btn-success w-100 mt-3" onClick={handleProceedToPay}>
                  Proceed to Pay
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Receiver Modal */}
      {showReceiverModal && (
        <div className="modal-backdrop">
          <div className="modal-content p-3">
            <div className="modal-header">
              <h5 className="modal-title">Receiver Details</h5>
              <button type="button" className="btn-close" onClick={() => setShowReceiverModal(false)}></button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Receiver Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  value={receiverInfo.name}
                  onChange={handleReceiverChange}
                  placeholder="Enter receiver name"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Phone Number</label>
                <input
                  type="tel"
                  className="form-control"
                  name="phone"
                  value={receiverInfo.phone}
                  onChange={handleReceiverChange}
                  placeholder="Enter phone number"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Address</label>
                <textarea
                  className="form-control"
                  name="address"
                  value={receiverInfo.address}
                  onChange={handleReceiverChange}
                  placeholder="Enter address"
                  rows={3}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={() => setShowReceiverModal(false)}>
                Cancel
              </button>
              <button type="button" className="btn btn-primary" onClick={handleReceiverSubmit}>
                Confirm & Pay
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default MenuList
